import { jsx as u, Fragment as Z } from "react/jsx-runtime";
import * as c from "react";
import { Children as v, isValidElement as j, cloneElement as w } from "react";
import './index.css';function J(t, e, o) {
  return {
    flexDirection: t,
    alignItems: t === "row" ? o : e,
    justifyContent: t === "row" ? e : o
  };
}
function O(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function K(...t) {
  return (e) => {
    let o = !1;
    const r = t.map((n) => {
      const s = O(n, e);
      return !o && typeof s == "function" && (o = !0), s;
    });
    if (o)
      return () => {
        for (let n = 0; n < r.length; n++) {
          const s = r[n];
          typeof s == "function" ? s() : O(t[n], null);
        }
      };
  };
}
var C = c.forwardRef((t, e) => {
  const { children: o, ...r } = t, n = c.Children.toArray(o), s = n.find(Q);
  if (s) {
    const l = s.props.children, i = n.map((y) => y === s ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : y);
    return /* @__PURE__ */ u(S, { ...r, ref: e, children: c.isValidElement(l) ? c.cloneElement(l, void 0, i) : null });
  }
  return /* @__PURE__ */ u(S, { ...r, ref: e, children: o });
});
C.displayName = "Slot";
var S = c.forwardRef((t, e) => {
  const { children: o, ...r } = t;
  if (c.isValidElement(o)) {
    const n = X(o);
    return c.cloneElement(o, {
      ...U(r, o.props),
      // @ts-ignore
      ref: e ? K(e, n) : n
    });
  }
  return c.Children.count(o) > 1 ? c.Children.only(null) : null;
});
S.displayName = "SlotClone";
var L = ({ children: t }) => /* @__PURE__ */ u(Z, { children: t });
function Q(t) {
  return c.isValidElement(t) && t.type === L;
}
function U(t, e) {
  const o = { ...e };
  for (const r in e) {
    const n = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? n && s ? o[r] = (...i) => {
      s(...i), n(...i);
    } : n && (o[r] = n) : r === "style" ? o[r] = { ...n, ...s } : r === "className" && (o[r] = [n, s].filter(Boolean).join(" "));
  }
  return { ...t, ...o };
}
function X(t) {
  var r, n;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, o = e && "isReactWarning" in e && e.isReactWarning;
  return o ? t.ref : (e = (n = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : n.get, o = e && "isReactWarning" in e && e.isReactWarning, o ? t.props.ref : t.props.ref || t.ref);
}
function tt(t) {
  var e = t.match(/^var\((.*)\)$/);
  return e ? e[1] : t;
}
function m(t, e) {
  var o = {};
  {
    var r = t;
    for (var n in r) {
      var s = r[n];
      s != null && (o[tt(n)] = s);
    }
  }
  return Object.defineProperty(o, "toString", {
    value: function() {
      return Object.keys(this).map((i) => "".concat(i, ":").concat(this[i])).join(";");
    },
    writable: !1
  }), o;
}
var f = { gap: "var(--_1lq33na0)", alignItems: "var(--_1lq33na1)", justifyContent: "var(--_1lq33na2)", flexDirection: "var(--_1lq33na3)", bleedTop: "var(--_1lq33na4)", bleedRight: "var(--_1lq33na5)", bleedBottom: "var(--_1lq33na6)", bleedLeft: "var(--_1lq33na7)" }, $ = "_1lq33na8";
const et = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  box: $,
  vars: f
}, Symbol.toStringTag, { value: "Module" })), mt = et ?? {};
function g({
  children: t,
  gap: e,
  asChild: o = !1,
  bleed: r,
  bleedTop: n,
  bleedRight: s,
  bleedBottom: l,
  bleedLeft: i,
  style: y = {},
  orientation: G = "column",
  xAlign: H = "initial",
  yAlign: B = "initial",
  ...x
}) {
  const F = o ? C : "div", p = J(G, H, B);
  typeof r == "number" && (r = `${r}px`);
  const a = r ? r.split(" ") : [];
  n = n ?? (a == null ? void 0 : a[0]), s = s ?? (a == null ? void 0 : a[1]) ?? (a == null ? void 0 : a[0]), l = l ?? (a == null ? void 0 : a[2]) ?? (a == null ? void 0 : a[0]), i = i ?? (a == null ? void 0 : a[3]) ?? (a == null ? void 0 : a[1]) ?? (a == null ? void 0 : a[0]);
  const Y = Object.assign(
    {},
    e !== void 0 && { [f.gap]: typeof e == "number" ? `${e}rem` : e },
    n && { [f.bleedTop]: _(n) },
    s && { [f.bleedRight]: _(s) },
    l && { [f.bleedBottom]: _(l) },
    i && { [f.bleedLeft]: _(i) },
    p.justifyContent !== "initial" && { [f.justifyContent]: p.justifyContent },
    p.alignItems !== "initial" && { [f.alignItems]: p.alignItems },
    p.flexDirection !== "column" && { [f.flexDirection]: p.flexDirection }
  );
  return /* @__PURE__ */ u(
    F,
    {
      ...x,
      className: `${$} ${x.className ?? ""}`,
      style: {
        ...y,
        ...m(Y)
      },
      children: t
    }
  );
}
function _(t) {
  return typeof t == "number" || t === "0" ? `${t}px` : t;
}
var N = "var(--h68q4h0)", b = "h68q4h1";
const nt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  flexGrow: N,
  stack: b
}, Symbol.toStringTag, { value: "Module" }));
function d(t = !1) {
  return rt(t);
}
function rt(t) {
  if (t !== !1)
    return t === !0 ? "1" : t == null ? void 0 : t.split("/");
}
const yt = nt ?? {};
function pt({
  children: t,
  expandChildren: e = !1,
  ...o
}) {
  const r = d(e);
  return /* @__PURE__ */ u(
    g,
    {
      ...o,
      className: `${b} ${o.className ?? ""}`,
      orientation: "column",
      children: r === void 0 ? t : v.map(t, (n, s) => n ? j(n) ? w(n, {
        style: {
          ...n.props.style,
          ...m({
            [N]: typeof r == "string" ? r : (r == null ? void 0 : r[s]) || "0"
          })
        }
      }) : n : null)
    }
  );
}
var h = "var(--_1gx5pa30)", q = "var(--_1gx5pa31)", P = "_1gx5pa32";
const ot = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  flexGrow: h,
  row: P,
  wrap: q
}, Symbol.toStringTag, { value: "Module" })), vt = ot ?? {};
function gt({
  children: t,
  wrap: e = "nowrap",
  expandChildren: o = !1,
  yAlign: r = "center",
  style: n = {},
  ...s
}) {
  e === !0 ? e = "wrap" : e === !1 && (e = "nowrap");
  const l = d(o);
  return /* @__PURE__ */ u(
    g,
    {
      ...s,
      className: `${P} ${s.className ?? ""}`,
      style: {
        ...n,
        ...m({
          [q]: e
        })
      },
      yAlign: r,
      orientation: "row",
      children: l === void 0 ? t : v.map(t, (i, y) => i ? j(i) ? w(i, {
        style: {
          ...i.props.style,
          ...m({
            [h]: typeof l == "string" ? l : (l == null ? void 0 : l[y]) || "0"
          })
        }
      }) : i : null)
    }
  );
}
var R = "var(--a0q09n0)", E = "var(--a0q09n1)", I = "a0q09n2";
const st = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clamp: I,
  maxHeight: E,
  maxWidth: R
}, Symbol.toStringTag, { value: "Module" })), _t = st ?? {};
function St({
  children: t,
  clamp: e,
  style: o = {},
  ...r
}) {
  const n = Array.isArray(e), s = n ? e[0] : e, l = n ? e[1] : void 0;
  if (l !== void 0 && v.count(t) > 1)
    throw Error(`<Clamp> with a vertical clamp set must be used with a single child only. Current children: ${v.count(t)}`);
  return /* @__PURE__ */ u(
    g,
    {
      ...r,
      className: `${I} ${r.className ?? ""}`,
      style: {
        ...o,
        ...m({
          ...s && { [R]: s },
          ...l && { [E]: l }
        })
      },
      orientation: "row",
      children: t
    }
  );
}
var M = "var(--_1mr9gdo0)", V = "var(--_1mr9gdo1)", z = "_1mr9gdo2";
const lt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  collapseAt: V,
  columns: z,
  flexGrow: M
}, Symbol.toStringTag, { value: "Module" })), jt = lt ?? {};
function wt({
  children: t,
  ratio: e,
  collapseAt: o = "0",
  ...r
}) {
  const n = d(e);
  return /* @__PURE__ */ u(
    g,
    {
      ...r,
      className: `${z} ${r.className ?? ""}`,
      style: {
        ...r.style ?? {},
        ...m({
          [V]: o
        })
      },
      orientation: "row",
      children: n === void 0 ? t : v.map(t, (s, l) => s ? j(s) ? w(s, {
        style: {
          ...s.props.style,
          ...m({
            [M]: typeof n == "string" ? n : (n == null ? void 0 : n[l]) || "1"
          })
        }
      }) : s : null)
    }
  );
}
var W = "var(--_1yo99wa0)", T = "var(--_1yo99wa1)", k = "_1yo99wa2";
const at = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  grid: k,
  gridItemMinWidth: W,
  gridMaxRowItems: T
}, Symbol.toStringTag, { value: "Module" })), dt = at ?? {};
function xt({
  children: t,
  gridItemMinWidth: e = "300px",
  gridMaxRowItems: o,
  style: r = {},
  ...n
}) {
  return /* @__PURE__ */ u(
    g,
    {
      ...n,
      className: `${k} ${n.className ?? ""}`,
      style: {
        ...r,
        ...m({
          [W]: e,
          [T]: o && String(o) || String(v.count(t))
        })
      },
      orientation: "row",
      children: t
    }
  );
}
var A = "_12fz4ez0";
const it = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  split: A
}, Symbol.toStringTag, { value: "Module" })), Ot = it ?? {};
function Ct({
  style: t = {},
  ...e
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      ...e,
      className: `${A} ${e.className ?? ""}`
    }
  );
}
var D = "_1gq2wfw0";
const ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  breakout: D
}, Symbol.toStringTag, { value: "Module" })), $t = ct ?? {};
function Nt({ children: t, ...e }) {
  return /* @__PURE__ */ u(
    g,
    {
      ...e,
      className: D,
      children: t
    }
  );
}
function bt(t) {
  return `.${t.split(" ").join(".")}`;
}
const ht = Symbol("Identifier for LYTS React components");
export {
  g as Box,
  Nt as Breakout,
  St as Clamp,
  wt as Columns,
  xt as Grid,
  gt as Row,
  Ct as Split,
  pt as Stack,
  mt as boxStyles,
  $t as breakoutStyles,
  _t as clampStyles,
  jt as columnsStyles,
  dt as gridStyles,
  ht as lytsId,
  vt as rowStyles,
  Ot as splitStyles,
  yt as stackStyles,
  bt as toSelectorString
};
